
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise-pos-solution",
      function () {
        return require("private-next-pages/enterprise-pos-solution.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise-pos-solution"])
      });
    }
  